// Screen-reader-only SEO content. Genuine, descriptive copy about the shop,
// its products and its Green Street / East London location. Invisible on screen
// (Tailwind `sr-only`) so it never affects the design, but fully crawlable and
// accessible. Rendered once, on the homepage only, to avoid duplicate content.
export const HiddenSeo = () => (
  <div className="sr-only" aria-hidden="false" data-testid="hidden-seo">
    <h1>
      Zebaa - South Asian Bridal &amp; Imitation Jewellery on Green Street, London
    </h1>
    <h2>Zebaa, Unit 1, 312 Green Street, London E13 9AP</h2>
    <p>
      Zebaa is a South Asian imitation jewellery shop on Green Street in East London.
      If you are looking for Zebaa, Zebaa Jewellery, Zebaa Green Street or Zebaa London,
      you have found us - our shop is at Unit 1, 312 Green Street, London E13 9AP, a short walk
      from Upton Park station and easily reached from East Ham station along the Barking Road.
    </p>
    <p>
      We specialise in South Asian bridal sets, kundan-style necklaces, polki-style
      chokers, temple jewellery, jhumkas, chandbalis, gold-tone bangles, kadas, chudi
      stacks, meenakari sets, maang tikkas, matha pattis, nose rings and hand-embellished
      bridal jewellery. Everything we stock is imitation (artificial) jewellery - gold-tone
      alloys, kundan-style settings, faux pearls and coloured stones - designed to look the
      part on the big day without the price tag of fine jewellery. Our pieces are perfect for
      weddings, engagements, mehndi and walima celebrations, Eid, parties and every special
      occasion, with pieces across every budget.
    </p>
    <p>
      Shoppers know us as one of the best imitation jewellery shops on Green Street and a
      trusted South Asian bridal jewellery shop in East London. Customers travel to Zebaa
      from Upton Park, East Ham, Forest Gate, Plaistow, Manor Park, Stratford, Ilford,
      Barking, Romford, Newham and across London and Essex. Visitors and tourists exploring
      the famous Green Street shopping district often ask for our website, so you can also
      browse and buy the full collection online at zebaa.uk with fast, tracked UK-wide
      Royal Mail delivery and free delivery on orders over £40.
    </p>
    <p>
      People find us by searching for a South Asian jewellery shop on Green Street, a bridal
      jewellery shop in London, kundan-style necklaces in Upton Park, Indian imitation
      jewellery shops in East London, wedding jewellery shops near Upton Park, and Asian
      bridal jewellery shops near East Ham and Forest Gate. We are open Monday to
      Saturday from 10am to 7pm and Sunday from 11am to 5pm. Contact us at hello@zebaa.uk
      or on Instagram @zebaa.uk.
    </p>
  </div>
);
